import { Measurement } from "@cur8/rich-entity";
import { MetricConfig } from "./measurementConfig";

export function formatMeasurementValue(
  config: MetricConfig,
  measurement: Measurement | undefined
): string | undefined {
  if (!measurement) {
    return undefined;
  }

  const values = config.dimensions
    .map((dimConfig) => {
      const dim = measurement.dimensions.find((d) => d.name === dimConfig.name);
      return dim == null ? null : { value: dim.value, unit: dimConfig.unit };
    })
    .filter((v): v is { value: number; unit: string } => v != null);

  if (values.length === 0) {
    return undefined;
  }

  // Same-unit dimensions (e.g. systolic/diastolic) collapse to standard "120/80 mm Hg" notation.
  const sharedUnit = values.every((v) => v.unit === values[0].unit)
    ? values[0].unit
    : null;

  if (sharedUnit != null) {
    return `${values.map((v) => v.value).join("/")} ${sharedUnit}`;
  }

  return values.map((v) => `${v.value} ${v.unit}`).join(" / ");
}

// Placeholder shown before a metric has been measured, e.g. "kg" or "mm Hg"
// for same-unit dimension pairs like systolic/diastolic, rather than "mm Hg / mm Hg".
export function formatUnitPlaceholder(config: MetricConfig): string {
  const units = config.dimensions.map((d) => d.unit);
  const sharedUnit = units.every((u) => u === units[0]) ? units[0] : null;
  return sharedUnit ?? units.join(" / ");
}
